<script setup lang="ts">
import { useI18n } from 'petite-vue-i18n';
import { Session, sessionMap } from '../../types/session';
import Button from '../General/Button.vue';
import Heading from '../General/Heading.vue';
import { TEXT } from '../../configs/text';
import { computed, ref } from 'vue';
import { useSessionStore, useSignalRStore } from '../../stores';
import { ClassStudentInfo } from '../../types/class';
import SetPoint from './SetPoint.vue';


interface Props {
    student: ClassStudentInfo
}
const { student } = defineProps<Props>()
const emit = defineEmits<{ update: [] }>()

const sessionStore = useSessionStore()
const signalr = useSignalRStore()

const pointSessionSelected = ref<Session>(sessionStore.currentSession)
const sessionPoint = computed<number>(() => student.point?.[pointSessionSelected.value] || 0)

function handleSessionClick(session: Session) {
    pointSessionSelected.value = session
}

function handlePointUpdate(updatePoint: number) {
    const pointToAdd = updatePoint - sessionPoint.value
    signalr.rewardPointStudent(student.id, pointToAdd, pointSessionSelected.value)
    emit('update')
}

const { t } = useI18n()
</script>

<template>
    <Heading alignment="center">{{ t(TEXT.reward_point) }}</Heading>
    <div class="flex flex-wrap gap-3 items-center justify-center my-5">
        <Button v-for="session in Session" :color="pointSessionSelected === session ? 'info' : 'light'" :shadow="false"
            :border="false" class="font-normal text-sm min-w-28" @click="handleSessionClick(session)">
            <div>
                <div>{{ t(sessionMap[session]) }}</div>
                <div class="text-2xl font-bold">{{ student.point?.[session] || 0 }}</div>
            </div>
        </Button>
    </div>
    <div class="text-center mb-1">
        {{ t(TEXT.reward_point_for_session, { session: t(sessionMap[pointSessionSelected]) }) }}
    </div>
    <div class="text-center font-bold text-xl">
        {{ student.full_name }}
    </div>
    <SetPoint :key="sessionPoint" :point="sessionPoint" @update="handlePointUpdate" />
</template>